module.exports = __webpack_public_path__ + "img/about_banner01.43a3da57.jpg";